import { cnva } from '@/app/utils/cnva';

const SPARTAN_TABS_MOTION_CLASS_NAME =
  'motion-safe:duration-300 motion-safe:ease-[cubic-bezier(0.4,0,0.2,1)]';

/** Dark track inset ring — only for orange / white glow indicators. */
export const SPARTAN_TABS_DARK_TRACK_STROKE_CLASS_NAME =
  'before:pointer-events-none before:absolute before:inset-0 before:z-4 before:rounded-md before:border before:border-gray-800 before:content-[""]';

export const SpartanTabsStyled = cnva(
  'relative isolate flex w-full overflow-visible rounded-md p-1',
  {
    variants: {
      variant: {
        light: 'bg-gray-700 backdrop-blur-sm',
        filled: 'bg-gray-100 backdrop-blur-md',
        soft: 'bg-white backdrop-blur-sm',
        dark: 'bg-gray-700/40 backdrop-blur-sm',
        'dark-on-light': 'overflow-hidden bg-white/70 backdrop-blur-sm',
        lime: [
          'overflow-hidden rounded-md',
          'bg-[rgba(29,29,29,0.5)] backdrop-blur-md',
        ].join(' '),
        mist: [
          'overflow-hidden rounded-md',
          'bg-[rgba(29,29,29,0.5)] backdrop-blur-md',
        ].join(' '),
      },
    },
    defaultVariants: {
      variant: 'filled',
    },
  }
);

export const SpartanTabsIndicatorStyled = cnva(
  [
    'pointer-events-none absolute inset-y-1 left-1 z-0 motion-safe:transition-transform',
    SPARTAN_TABS_MOTION_CLASS_NAME,
  ],
  {
    variants: {
      variant: {
        light: 'rounded-sm bg-white',
        filled: 'rounded-sm bg-gray-800',
        soft: 'rounded-sm bg-gray-800',
        dark: '',
        'dark-on-light': '',
        lime: '',
        mist: '',
      },
    },
    defaultVariants: {
      variant: 'filled',
    },
  }
);

export const SpartanTabsItemStyled = cnva(
  [
    'font-noto-bold text-body-2 relative z-1 flex min-h-10 flex-1 items-center justify-center rounded-sm px-2 pt-1.75 pb-1.5 leading-tight! outline-none motion-safe:transition-colors',
    SPARTAN_TABS_MOTION_CLASS_NAME,
  ],
  {
    variants: {
      variant: {
        light: '',
        filled: '',
        soft: '',
        dark: '',
        'dark-on-light': '',
        lime: '',
        mist: '',
      },
      isSelected: {
        true: 'cursor-default',
        false:
          'cursor-pointer bg-transparent text-gray-700 hover:text-gray-900',
      },
      isSingle: {
        true: 'cursor-default',
        false: '',
      },
      indicatorTone: {
        orange: '',
        blue: '',
        white: '',
        lime: '',
        mist: '',
      },
    },
    compoundVariants: [
      {
        variant: 'light',
        isSelected: true,
        className: 'text-gray-900',
      },
      {
        variant: 'light',
        isSelected: false,
        className: 'text-gray-400 hover:text-white',
      },
      {
        variant: 'filled',
        isSelected: true,
        className: 'text-white',
      },
      {
        variant: 'filled',
        isSelected: false,
        className: 'text-gray-400 hover:text-gray-900',
      },
      {
        variant: 'soft',
        isSelected: true,
        className: 'text-white',
      },
      {
        variant: 'soft',
        isSelected: false,
        className: 'text-gray-400 hover:text-gray-900',
      },
      {
        variant: 'dark',
        isSelected: true,
        className: 'text-white',
      },
      {
        variant: 'dark',
        indicatorTone: 'white',
        isSelected: true,
        className: 'text-gray-900',
      },
      {
        variant: 'dark',
        isSelected: false,
        className: 'text-gray-300 hover:text-white',
      },
      {
        variant: 'dark',
        indicatorTone: 'lime',
        isSelected: false,
        className: 'text-gray-100 hover:text-white',
      },
      {
        variant: 'dark-on-light',
        isSelected: true,
        className: 'text-white',
      },
      {
        variant: 'dark-on-light',
        isSelected: false,
        className: 'text-gray-600 hover:text-gray-900',
      },
      {
        variant: 'lime',
        isSelected: true,
        className: 'text-gray-700',
      },
      {
        variant: 'lime',
        isSelected: false,
        className: 'text-gray-100 hover:text-white',
      },
      {
        variant: 'mist',
        isSelected: true,
        className: 'text-gray-700',
      },
      {
        variant: 'mist',
        isSelected: false,
        className: 'text-gray-100 hover:text-white',
      },
      {
        variant: 'light',
        isSingle: true,
        className: 'text-white',
      },
      {
        variant: 'filled',
        isSingle: true,
        className: 'text-gray-900',
      },
      {
        variant: 'soft',
        isSingle: true,
        className: 'text-gray-900',
      },
      {
        variant: 'dark',
        isSingle: true,
        className: 'text-white',
      },
      {
        variant: 'dark-on-light',
        isSingle: true,
        className: 'text-white',
      },
      {
        variant: 'lime',
        isSingle: true,
        className: 'text-gray-700',
      },
      {
        variant: 'mist',
        isSingle: true,
        className: 'text-gray-700',
      },
      {
        variant: 'dark',
        indicatorTone: 'white',
        isSelected: true,
        isSingle: true,
        className: 'text-gray-900',
      },
    ],
    defaultVariants: {
      variant: 'filled',
      isSelected: false,
      isSingle: false,
      indicatorTone: 'orange',
    },
  }
);
